import { Link } from "react-router-dom";

interface ArticleCardProps {
  id: string;
  title: string;
  excerpt: string;
  coverImage: string;
  author: string;
  publishDate: string;
  readCount: string;
  tags: string[];
  category: string;
}

export default function ArticleCard({
  id,
  title,
  excerpt,
  coverImage,
  author,
  publishDate,
  readCount,
  tags,
  category,
}: ArticleCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group flex flex-col sm:flex-row gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-accent-300 transition-all cursor-pointer"
    >
      <div className="w-full sm:w-[200px] aspect-video sm:aspect-[4/3] rounded-lg overflow-hidden bg-background-100 shrink-0">
        <img
          src={coverImage}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          loading="lazy"
        />
      </div>

      <div className="flex-1 min-w-0">
        <h3 className="text-base font-medium text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
          {title}
        </h3>
        <p className="text-sm text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
          {excerpt}
        </p>

        <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2 flex-wrap">
          <span className="flex items-center gap-1">
            <i className="ri-user-line text-xs"></i>
            {author}
          </span>
          <span className="text-foreground-300">|</span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line text-xs"></i>
            {publishDate}
          </span>
          <span className="text-foreground-300">|</span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line text-xs"></i>
            {readCount}阅读
          </span>
        </div>

        <div className="flex items-center gap-1.5 flex-wrap">
          {tags.map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 rounded-full text-[10px] bg-secondary-100 text-secondary-700"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}